<template>
    <div>
        <ul
            class="nav nav-tabs tab-deactive"
            style="background-color: #eff3f6; border-bottom-color: transparent !important"
        >
            <li v-for="(tag, index) in tags" class="nav-item" style="cursor: pointer">
                <div
                    :id="`clickme_${tag.name}`"
                    @click="routeTo(tag, index)"
                    :class="{'nav-link': true, active: index === activeIndex}"
                >
                    {{ tag.name }}
                </div>
            </li>
        </ul>
        <router-view />
    </div>
</template>

<script>
import _ from 'lodash';
export default {
    name: 'AuditMain',
    data() {
        let tabs = {
            email: null,
            selectedLocale: null,
            formRoutes: ['Detail'],
            activeIndex: 0,
            tags: [
                {
                    name: this.$t(this.getImproprietyName()),
                    path: 'audit'
                }
            ]
        };
        if (
            _.get(this.$store.state.user.assignedSites,'length') > 0
        ) {
            tabs.tags = [
                {
                    name: this.$t('Audit'),
                    path: 'Detail'
                }, //'Summary','Detail'
                ...tabs.tags
            ];
        }
        return tabs;
    },
    methods: {
        routeTo(tag, index) {
            this.activeIndex = index;
            if(this.activeIndex == 1 || this.$store.state.siteId){
                this.$router.push({
                    name: tag.path,
                    query: {year: this.year} // this.activeIndex === 0 ? {} : 
                });
                return Promise.resolve();
            }else{
                this.$router.push({
                    name: this.$t('Summary'),
                    query: {year: this.year}
                });
                return Promise.resolve();
            }
            
        },
        // Toggle active tags
        setTags() {
            // 'doc' is for the current component. by default 'doc' routed forced to 'files'.
            // When a user click back button, page should not route to 'doc' because it does not belongs to any tag.
            // To solve the problem above, 'doc' route replaced with tag's route.
            if (this.route.name === 'auditMain') {
                this.tags[0].active = true;
                //this.tags[1].active = false;
                this.$router.replace({name: this.tags[0].path, query: {year: this.year}});
            } else if (this.formRoutes.indexOf(this.route.name) !== -1) {
                // if route belongs the formRoute, form tag will be activated.
                this.tags[0].active = false;
                //this.tags[1].active = true;
            } else {
                this.tags[0].active = true;
                //this.tags[1].active = false;
            }
        },
        getImproprietyName() {
            return this.gbId(this.$store.state.user.customerId) ? 'garantiImpropriety' : 'Impropriety'
        },
        setActiveIndex(){
            this.activeIndex = this.route.name === 'audit' || this.route.name === 'ticket-list' ? 1 : 0;
        }
    },
    created() {
        this.setTags();
        this.setActiveIndex();
    },
    // After Main component is loaded, needs handling of route changes to specify active tag;
    beforeRouteUpdate(to, from, next) {
        next();
        this.setTags();
    }
};
</script>

<style scoped>
</style>


<i18n src="../../i18n/common.json"></i18n>



// WEBPACK FOOTER //
// src/views/Audit/AuditMain.vue